"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIntersectionObserver;
var _react = require("react");
function useIntersectionObserver({
  ref,
  unmountAfterIntersection = false,
  disabled = false,
  options
}) {
  const [didIntersect, setDidIntersect] = (0, _react.useState)(false);
  const [isIntersecting, setIsIntersecting] = (0, _react.useState)(false);
  const [mounted, setMounted] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);
  (0, _react.useEffect)(() => {
    if (!ref.current || disabled || !mounted) {
      return () => {};
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === ref.current && entry.isIntersecting) {
          setIsIntersecting(true);
          setDidIntersect(true);
          if (unmountAfterIntersection) {
            observer.unobserve(ref.current);
          }
        }
        if (entry.target === ref.current && !entry.isIntersecting) {
          setIsIntersecting(false);
        }
      });
    }, options);
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref, unmountAfterIntersection, disabled, mounted, options]);
  return {
    isIntersecting,
    didIntersect
  };
}
